module.exports = __webpack_public_path__ + "img/lc.78602fd9.svg";